import {
    GET_MERCHANT_OUTLET_TRANSACTION_FAILED, GET_MERCHANT_OUTLET_TRANSACTION_SUCCESS, GET_MERCHANT_OUTLET_TRANSACTION_LOADING, REMOVE_MERCHANT_OUTLET_TRANSACTION

} from "../types";

const initialState = {
    outletsChartData: null,
    loading: null,
    error: null,
};

export const getOutletsTransactionChartReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
) => {
    switch (action.type) {
        case GET_MERCHANT_OUTLET_TRANSACTION_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_MERCHANT_OUTLET_TRANSACTION_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                outletsChartData: action.payload,
            };
        case GET_MERCHANT_OUTLET_TRANSACTION_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case REMOVE_MERCHANT_OUTLET_TRANSACTION:
            return initialState;

        default:
            return state;
    }
};
